import { legacyPlugins } from "/tmp/build_712b8c35/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}